import { render } from "./StandardContentNew.vue?vue&type=template&id=46a9952c"
import script from "./StandardContentNew.vue?vue&type=script&lang=js"
export * from "./StandardContentNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__